import styled from "styled-components";

export const SetupOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 99999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.58);
  backdrop-filter: blur(4px);

  @media (max-width: 480px) {
    align-items: flex-end;
    padding: 0;
  }
`;

export const SetupDialog = styled.form`
  width: min(100%, ${({ width }) => width || "460px"});
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.28);

  @media (max-width: 480px) {
    width: 100%;
    max-height: 92dvh;
    border-radius: 16px 16px 0 0;
  }
`;

export const SetupHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 18px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;

  h2 {
    margin: 0;
    color: #0f172a;
    font-size: 20px;
    font-weight: 800;
  }

  @media (max-width: 480px) {
    padding: 18px 16px 14px;
  }

  p {
    margin: 6px 0 0;
    color: #64748b;
    font-size: 13px;
    line-height: 1.45;
  }
`;

export const CloseButton = styled.button`
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;

  &:hover {
    background: #f1f5f9;
    border-color: #94a3b8;
    color: #0f172a;
  }
`;

export const SetupBody = styled.div`
  padding: 22px 24px;
  overflow-y: auto;

  @media (max-width: 480px) {
    padding: 18px 16px;
  }
`;

export const SetupFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;
  background: #fff;

  @media (max-width: 480px) {
    padding: 12px 16px max(12px, env(safe-area-inset-bottom));

    button {
      flex: 1;
    }
  }
`;

export const SecondaryButton = styled.button`
  min-height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;

  &:hover {
    background: #f8fafc;
  }
`;

export const PrimaryButton = styled.button`
  min-height: 40px;
  padding: 0 18px;
  border-radius: 8px;
  border: 0;
  background: #30d5c8;
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #26a79d;
  }
`;

export const HelperText = styled.p`
  margin: 6px 0 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.4;
`;

export const ImageUploadBox = styled.label`
  min-height: 112px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  border: 1px dashed #94a3b8;
  border-radius: 8px;
  background: #f8fafc;
  color: #475569;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;

  input {
    display: none;
  }
`;

export const ImagePreview = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;

  img {
    width: 88px;
    height: 88px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: #fff;
  }
`;
